import { TaskApplication } from '../../../pages/superuser/types'

export interface SourceMapQueryParams {
  companyId?: string
  source: TaskApplication
  localEntity: string
  sourceEntity: string
}

const sourceMapQueryKeys = {
  all: [{ scope: 'sourceMap' }] as const,
  lists: () => [{ ...sourceMapQueryKeys.all[0], entity: 'list' }] as const,
  list: (params: SourceMapQueryParams) => [{ ...sourceMapQueryKeys.lists()[0], ...params }] as const,
  suggestionLists: () => [{ ...sourceMapQueryKeys.all[0], entity: 'suggestions' }] as const,
  suggestions: (params: SourceMapQueryParams) => [{ ...sourceMapQueryKeys.suggestionLists()[0], ...params }] as const
}

export default sourceMapQueryKeys
